// app/components/ConditionalHeader.tsx
'use client'
import React from 'react'
import { usePathname } from 'next/navigation'
import { Header } from './Header'

function ConditionalHeader() {
  const pathname = usePathname()

  // Adjust the logic as needed:
  const hideHeader =
    pathname!.includes('/chart') || pathname === '/home' || pathname!.startsWith('/home/') || pathname!.includes('/flutter-chat') || pathname!.includes('/backtest') || pathname!.includes('/smart-wallet') || pathname!.includes('/baskets') || pathname!.includes('/historicals') || pathname!.includes('/options-builder') || pathname!.includes('/sentiment') || pathname!.includes('/tax-report') || pathname!.includes('/auth/') || pathname!.includes('/x/') || pathname!.includes('/ningenie') || pathname!.includes('/ningenie/') || pathname!.includes('/mobile-chat-viewer-simple') || pathname!.includes('/ningenie/mobile-chat-viewer-simple/') || pathname!.includes('/ninx') || pathname!.includes('/ninx/') || pathname!.includes('/nincrew')
    
  if (hideHeader) return null

  return <Header />
}

export default React.memo(ConditionalHeader)
export { ConditionalHeader as Header }
